var jquery = require("jquery");
$ = window.$ = window.jQuery = jquery; // notice the definition of global variables here

const Handlebars = require("handlebars");
const Moment = require('moment');


// Add the Firebase services that you want to use
import firebase from "firebase/app";

import "firebase/auth";
import "firebase/analytics";
import "firebase/database";
import "firebase/firestore";

import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

//

if(window.document.documentMode){
    document.getElementById('main-preloader').innerHTML = '<div class="col s8 offset-s2"><h3>This browser is not supported. Please use Apple Safari, Mozilla Firefox, Microsoft Edge or Google Chrome</h3></div>';
}
if (window.location.href.indexOf("http://localhost") === -1){
    window.console.log = function(){
        console.info('© 2021, CMEfy @ SCAD.Ventures');
        window.console.log = function() {
            return false;
        }
    }
}

!(function() {
    // MIJI JSKJM
    var CURR_UserProfile;
    var CURR_UserAccountState;

    var PRE_CONTEXT_App = false;
    var REDIR_URL = false;
    var SHOW_LinkCreator = false;
    var CHECK_StripeCustomerStatus = false;

    $(document).ready((et)=>{
        $('#main-preloader').show();
        $('.auth-view').hide();
        $('.unauth-view').hide();
        //
        if (getUrlParameter('session_id') || getUrlParameter('checkSubscription')){
            CHECK_StripeCustomerStatus = true;
        }
        //
        InitializeUIElements();
        AUTH_FirebaseInitAndAuthCheck();
        //
    });

    var HELP_Timer = false;
    function InitializeUIElements(){
        //
        $(window).scroll(function() {
            console.log("scrolled");
            Beacon_initAndShowWithDelay();
            if (window.scrollY < 81){
                $('.cmefy-header-bar').removeClass('shadow');
            }else{
                $('.cmefy-header-bar').addClass('shadow');
            }
        });
        //
        M.Sidenav.init(document.querySelectorAll('.sidenav'), {});
        //
        M.Tooltip.init(document.querySelectorAll('.tooltipped'), {});
        //
        M.Collapsible.init(document.querySelectorAll('.collapsible'));
        // For first time users :) after a delay
        M.TapTarget.init(document.querySelectorAll('.tap-target'));
        //
        M.Carousel.init(document.querySelectorAll('.carousel'),{
            duration:0,
            dist: 0,
            indicators: true
        });
        // we need a listener on window closing
        M.Modal.init(document.querySelector('#faqModal'), {
            dismissible: true,
            opacity: 0.63,
            startingTop: '5%',
            endingTop: '5%'
        });
        //
        M.FloatingActionButton.init(document.querySelector('.fixed-action-btn'),{
            toolbarEnabled:false,
            hoverEnabled:false,
            direction: 'left'
        });
        M.FormSelect.init(document.querySelectorAll('select'), {});
        //
        M.Tabs.init(document.querySelectorAll('.tabs'), {
        });
        //
        M.Dropdown.init(document.querySelectorAll('.dropdown-trigger'));
    }

    // TASK MANAGER
    function UI_BindBtnTasks_Clicks(){
        $(document).on('click','.ui-action-btn', function(){
            return performUITask($(this).data("task"));
        });

        $(document).on('click', '.copy-contents-btn', function(em){
            console.log(this.innerHTML);
            const el = document.createElement('textarea');
            el.value = this.innerHTML;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            //
            M.toast({html:"✅&nbsp;&nbsp;URL copied"});
        });

        $(document).on('change', '#display_name', (e)=>{
            if (!CURR_UserProfile.cmefy_handle){
                var handledName = $('#display_name').val().trim().split(" ").join("-").split("'").join("").split(".").join("").toLowerCase();
                // we must add part of the uid to the handled name to avoid collisions
                checkAndSanitizeHandle(handledName, sanitizedHandle=>{
                    handledName = sanitizedHandle;
                    $('#catalyst_handle').val(handledName);
                    $('#public_profile_url').val(`https://cmefy.com/u/${handledName}`);
                    M.updateTextFields();
                });
            }
        })
    }

    function performUITask(task){
        
        switch (task){
            case "stripe::navigate-to-portal":
                window.location.href = STRIPE_PORTAL_URL;
                break;
            case "confirm-logout":
                M.toast({html: '<span>Logout?</span><button class="btn-flat toast-action ui-action-btn" data-task="logout-yes">Yes</button><button class="btn-flat toast-action ui-action-btn" data-task="logout-no">No</button>'})
                break;
            case "logout-yes":
                firebase.auth().signOut();
                window.location.reload();
                break;
            case "logout-no":
                M.Toast.dismissAll();
                break;
            default:
                console.log("No op");
                break;
        }

    }

    var STRIPE_PORTAL_URL = false;
    function UI_ProcessSubscriptionFlow(){
        FB_AuthGetToken(uidToken=>{
            if (uidToken){
                if (CHECK_StripeCustomerStatus){
                    // CHECK POINT: 1. Check status and then route. If session_id, we need to verify on a timer before going back to the app
                    firebase.firestore().collection("cmefy_user_statemgmt").doc(firebase.auth().currentUser.uid).onSnapshot(userSnapshot=>{
                        if (userSnapshot.exists){
                            var statusPacket = userSnapshot.data();
                            // let's see what status we're at
                            let stripe_subscription_flag = false;
                            if (statusPacket.stripe_subscription){
                                if (statusPacket.stripe_subscription.status === "active"){
                                    window.location.href = "/?app&subscriptionSuccessful";
                                }
                            }
                        }
                    });            
                }else{
                    // smart navigate to subscription status
                    $.ajax({
                        url: `stripe/smart-router?uidToken=${uidToken}`,
                        method: `POST`,
                        dataType: "json",
                        success: (stripePacket) => {
                            if (stripePacket.error){
                                return ERROR_Alerter(stripePacket.error);
                            }
                            console.log(stripePacket);
                            //
                            if (stripePacket.url){
                                STRIPE_PORTAL_URL = stripePacket.url;
                                if (stripePacket.object === "checkout.session"){
                                    // we don't navigate, we offer the insights to why we are so magical WGG JSKJM
                                    $('#checkerNudge').remove();
                                    $('#subscribeNudge').removeClass('hiddendiv');
                                }else{
                                    $('#subscribeNudge').remove();
                                    performUITask("stripe::navigate-to-portal");    
                                }
                            }
                        },
                        error: function(err){
                            ERROR_Alerter(err);
                        }
                    });
                }
            }

        }); 
        // DONE: 2. We should also make sure the verify-cmefy-user-token fun includes the subscription checkers & master overrides
        //
    }

    function UserAccount_CheckStatus(){
        if (CURR_UserAccountState.state === "subscribed"){
            return true;
        }else{
            if (CURR_UserAccountState.state === "activated" && CURR_CMEFIED_RECORDS_Count>0){
                return false;
            }
        }
    }

    var Beacon_inited = false;
    function Beacon_initAndShow(callback){
        if (!Beacon_inited) Beacon('init','60a77568-902f-477c-b2fd-2a725f4ed284');
        Beacon('on', 'ready', () => {
            Beacon_inited = true;
            if (callback) callback();

        })
    }

    function Beacon_initAndShowWithDelay(){
        if (HELP_Timer) clearTimeout(HELP_Timer);
        HELP_Timer = setTimeout(()=>{
            Beacon_initAndShow();
        }, 7200);

    }

    function Beacon_presentArticle(articleId){
        if (!articleId){
            articleId = '617348069ccf62287e5eecd7';
        }
        Beacon('article', articleId);
    }

    function remove_duplicates(arr) {
        var obj = {};
        var ret_arr = [];
        for (var i = 0; i < arr.length; i++) {
            obj[arr[i]] = true;
        }
        for (var key in obj) {
            ret_arr.push(key);
        }
        return ret_arr;
    }

    // AUTH Master
    function AUTH_FirebaseInitAndAuthCheck(){
        var firebaseConfig = {
            apiKey: "AIzaSyAGwxNtQFoExfy5h6QwsiXtRufkecGdKjo",
            authDomain: "cmefy-platform.firebaseapp.com",
            projectId: "cmefy-platform",
            storageBucket: "cmefy-platform.appspot.com",
            messagingSenderId: "920328618854",
            appId: "1:920328618854:web:09e10fa0f1e4ae21fdfea7",
            measurementId: "G-D6L8YYD6QE"
        };
        // Initialize Firebase
        firebase.initializeApp(firebaseConfig);
        firebase.analytics();
        //
        // Auth Checking Eventbased :)
        firebase.auth().onAuthStateChanged(function(user) {
            AUTH_CheckAndProceed(user);
        });
    }

    function AUTH_CheckAndProceed(user){
        if (user) {
            // check & show auth view
            if (getUrlParameter('logout')){ // search a nudge by text
                firebase.auth().signOut();
                history.pushState({},"CMEfy | Catalyzing Clinician Co-learning","/")
                window.location.reload();
            }
            //
            showAuthView();
            UI_BindBtnTasks_Clicks();
            //
            console.log(`user is valid`);
            //
            return UI_ProcessSubscriptionFlow();
            FB_AuthGetToken(uidToken=>{
                if (uidToken){
                    $.ajax({
                        url: `v2/verify-cmefy-token?uidToken=${uidToken}`,
                        dataType: "json",
                        success: (userValid) => {
                            CURR_UserAccountState = userValid;
                            console.log(`user is signed in: ${user.uid}`);
                            console.log(userValid);
                            if(userValid.allowed){
                                // TODO: Validate subscription status based on activity :)
                                showAuthView();
                                UI_BindBtnTasks_Clicks();
                                //
                                console.log(`user is valid`);
                                //
                                UI_ProcessSubscriptionFlow();
                            }else{
                                window.location.href = `/waitlist?e=${user.email}&u=${user.uid}&n=${user.displayName}`;
                            }
                        },
                        error: function(err){
                            ERROR_Alerter(err);
                            firebase.auth().signOut();
                        }
                    });
                }
            });
        }else{
            window.location.href = 'https://about.cmefy.com'
        }
    }

    function FB_LogEvent(event, packet){
        firebase.analytics().logEvent(event, packet);
    }

    function showAuthView(){
        $('#main-preloader').hide();
        //
        $('.auth-view').show();
        $('.unauth-view').hide();
        // let's do state management :)
        PRE_CONTEXT_App = getUrlParameter('app') || false;
        REDIR_URL = getUrlParameter('redir_url') || false;
        SHOW_LinkCreator = getUrlParameter('newflow')? true : false;
        // stripe management
        
    }
    

    function ERROR_Alerter(errObj){
        if (errObj){
            console.log(errObj);
            if (errObj.error){
                alert(JSON.stringify(errObj.error));
            }else{
                alert(JSON.stringify(errObj));
            }
        }else{
            alert("There was an error in your connection, please refresh this page.");
        }
    }

    function navigateToApp(){
        window.location.href = "/app";
    }

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    function animateCSS(element, animationName, callback) {
        const node = document.querySelector(element)
        node.classList.add('animated', animationName)

        function handleAnimationEnd() {
            node.classList.remove('animated', animationName)
            node.removeEventListener('animationend', handleAnimationEnd)

            if (typeof callback === 'function') callback()
        }

        node.addEventListener('animationend', handleAnimationEnd)
    }

    function FB_AuthGetToken(callback){
        firebase.auth().currentUser.getIdToken(true).then(function(idToken) {
            // Send token to your backend via HTTPS
            return callback(idToken);
            // ...
        }).catch(function(error) {
            // Handle error
            return callback(false);
        });
    }
})();